import { useSeo } from "../lib/seo";
import { useEffect, useState } from "react";
import { api } from "../lib/api";
import { Newsletter as SignupForm } from "../components/Newsletter";

export default function NewsletterPage() {
  useSeo({
    title: "The Dispatch — Newsletter | Quantum Boas",
    description: "Follow Quantum Boas breeding projects, litter announcements and future animal updates. Join the Dispatch for project news and collection updates first.",
  });
  const [posts, setPosts] = useState([]);
  const [sel, setSel] = useState("");

  useEffect(() => {
    api.get("/posts").then((r) => { setPosts(r.data); if (r.data[0]) setSel(r.data[0].id); }).catch(() => {});
  }, []);

  const current = posts.find((p) => p.id === sel);

  return (
    <div className="grain pt-32 pb-8 px-6 md:px-10 min-h-screen">
      <div className="max-w-[900px] mx-auto">
        <span className="text-xs tracking-[0.25em] uppercase text-qbprimary">The Dispatch</span>
        <h1 className="font-display text-5xl sm:text-6xl md:text-7xl mt-4 mb-6 leading-[1.02] pb-1">Newsletter</h1>

        {posts.length === 0 ? (
          <p className="text-qbfg/50 py-12">No issues published yet — subscribe below to get the first one.</p>
        ) : (
          <>
            <div className="mb-8">
              <label className="text-xs uppercase tracking-wider text-qbfg/40 block mb-2">Browse past issues</label>
              <select data-testid="newsletter-issue-select" value={sel} onChange={(e) => setSel(e.target.value)}
                className="w-full sm:w-[28rem] bg-qbsurface text-qbfg border border-white/15 rounded-lg px-4 py-3 outline-none focus:border-qbprimary">
                {posts.map((p) => <option key={p.id} value={p.id} className="bg-qbsurface text-qbfg">{p.title} — {new Date(p.created_at).toLocaleDateString()}</option>)}
              </select>
            </div>
            {current && (
              <article data-testid="newsletter-article" className="border-t border-white/10 pt-8">
                <p className="text-xs text-qbfg/40 uppercase tracking-wider mb-2">{new Date(current.created_at).toLocaleDateString(undefined, { year: "numeric", month: "long", day: "numeric" })}</p>
                <h2 className="font-display text-3xl md:text-4xl mb-5 leading-[1.1] pb-1">{current.title}</h2>
                <div className="text-qbfg/70 leading-relaxed whitespace-pre-wrap">{current.body}</div>
              </article>
            )}
          </>
        )}
      </div>
      <div className="max-w-[1400px] mx-auto"><SignupForm /></div>
    </div>
  );
}
